<template>
  <div class="callback-page">
    <template v-if="!errorMessage">
      <div class="spinner" aria-hidden="true" />
      <p>Concluindo autenticação...</p>
    </template>
    <div v-else class="callback-error" role="alert">
      <h1>Não foi possível concluir a autenticação</h1>
      <p>{{ errorMessage }}</p>
      <button class="button primary" type="button" @click="tryAgain">Tentar novamente</button>
    </div>
  </div>
</template>

<script>
import authService from '../auth/oidc'

export default {
  name: 'AuthCallbackView',
  data: () => ({
    errorMessage: ''
  }),
  async mounted () {
    try {
      const returnPath = await authService.completeSignInRedirect()
      await this.$router.replace(returnPath)
    } catch (error) {
      await authService.clearAuthState()
      this.errorMessage = error?.error_description || error?.message || 'O AuthServer recusou a troca do código de autorização pelo token.'
    }
  },
  methods: {
    async tryAgain () {
      this.errorMessage = ''
      await authService.signInRedirect('/home')
    }
  }
}
</script>
